import Link from "next/link";
import { useRouter } from "next/router";

export function AppLink({
  navigate,
  children,
  className,
  path,
  onClick,
  ...props
}) {
  const router = useRouter();
  return (
    <Link
      {...props}
      className={className || ""}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.(event);
        if (navigate) router.push(path);
      }}
      href={path || "/"}
    >
      {children}
    </Link>
  );
}

export default AppLink;
